var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgGameStats = function SvgGameStats(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#F5A300",
    d: "M1.638 16.8h6.354c.373 0 .675.199.675.444v4.836H.963v-4.836c0-.245.302-.444.675-.444"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFB800",
    d: "M9.914 11.625h6.172c.362 0 .655.292.655.651v9.683H9.26v-9.683c0-.36.293-.65.655-.65"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFC500",
    d: "M18.008 5.76h6.355c.372 0 .674.922.674 2.056V22.08h-7.704V7.816c0-1.136.303-2.056.675-2.056M25.35 24H.65a.65.65 0 0 1-.65-.646c0-.356.291-.646.65-.646h24.7c.359 0 .65.29.65.646a.65.65 0 0 1-.65.646"
  })));
};
export default SvgGameStats;